import {
    ContentSectionContainer,
    EEditorType,
    FullBar,
    GenericWrapperContext,
    Header
} from "@cakemail-org/ui-components-v2"
import { useContext } from "react"
import { useTranslation } from "react-i18next"
import BeeEditor from "../../components/beeEditor"
import { EEditorCssFileName } from "../../components/beeEditor/types"
import { ImagesContext } from "./context"
import "./styles.scss"
import { TFileManager } from "./types"


export default function FileManager({ }: TFileManager) {

    const { t } = useTranslation()
    const genericWrapper = useContext(GenericWrapperContext)
    return <ContentSectionContainer className="imagesContainer">
        <ImagesContext.Provider value={{}}>
            <FullBar
                left={<Header
                    heading={t("file-manager-title")}
                    headingVariant="titleL"
                    support={genericWrapper.account?.name}
                    headingTooltip={t("file-manager-tooltip")}
                />}
            />
            <BeeEditor
                className="beeEditorModal beeFileManager"
                variant="inline"
                cssFileName={EEditorCssFileName.fileManager}
                editorType={EEditorType.fileManager}
            />
        </ImagesContext.Provider>
    </ContentSectionContainer>
}